module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@3x-2a0ad05245e0545892535ba58313ab79.png";